module.exports = __webpack_public_path__ + "img/best-price-en-d.aab0d80.webp";